var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.38,100.07l-2.43-4c-20.52-33.81-57.61-54.19-96.72-51.72a102.44,102.44,0,0,0-15,2.06C285.7,54,254.77,80.9,241.94,115.34c-7.54,20.25-9.65,43.57-24,59.64-18.63,20.92-50.25,21.58-78.06,20.71s-59.44-.12-78,20.88c-11.61,13.16-15.3,31.86-14.36,49.48,2.47,46.64,35,88.34,76.31,109.07s90,22.59,135.23,13.47c63.37-12.77,123.63-47.85,159.86-102S464.37,158.55,435.38,100.07Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.25,401.76l-124.93-.08a27.2,27.2,0,0,1-27.19-27.21l.06-313.19a27.22,27.22,0,0,1,27.23-27.21l124.92.08a27.22,27.22,0,0,1,27.2,27.21l-.07,313.19A27.21,27.21,0,0,1,300.25,401.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.93,45.32l-24.22,0a6,6,0,0,0-5.88,6.15v4.39A6,6,0,0,1,263.94,62l-47.21,0a6,6,0,0,1-5.88-6.15v-4.4A6,6,0,0,0,205,45.26h-8.52l-21.19,0A19.06,19.06,0,0,0,156.19,64.3L156.13,370a19,19,0,0,0,19,19.06l124.68.07a19.06,19.06,0,0,0,19.07-19.05L319,64.38A19.06,19.06,0,0,0,299.93,45.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.37,93.89c0,.14-36.81.26-82.2.26S156,94,156,93.89s36.8-.26,82.22-.26S320.37,93.74,320.37,93.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,82.56a.5.5,0,0,1-.33-.12l-4.75-4.17a.46.46,0,0,1-.17-.38.48.48,0,0,1,.18-.38l4.75-4a.5.5,0,0,1,.7.07.49.49,0,0,1-.07.7l-4.29,3.58,4.3,3.78a.49.49,0,0,1,.05.7A.48.48,0,0,1,173.15,82.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.8,77.62c0,.15-15.47.26-34.56.26s-34.56-.11-34.56-.26,15.47-.26,34.56-.26S276.8,77.48,276.8,77.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.82,77.59a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,296.82,77.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,77.59a1.8,1.8,0,1,1-1.79-1.8A1.79,1.79,0,0,1,302,77.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.19,77.59a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,307.19,77.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.57,161.05c0,1.16-.48,1.86-1.28,1.86a.8.8,0,0,1-.85-.59,1.37,1.37,0,0,1-1.21.59,1.71,1.71,0,0,1,0-3.41,1.38,1.38,0,0,1,1.12.48v-.44h.74v2.28c0,.34.16.46.35.46.36,0,.56-.43.56-1.22a2.36,2.36,0,0,0-2.57-2.39,2.51,2.51,0,1,0,0,5,2.91,2.91,0,0,0,1.3-.3l.18.54a3.41,3.41,0,0,1-1.48.31,3.06,3.06,0,1,1,0-6.11A2.92,2.92,0,0,1,222.57,161.05Zm-2.21.15a1,1,0,1,0-1,1.06A1,1,0,0,0,220.36,161.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36,162.87c0,.14-7.24.26-16.16.26s-16.15-.12-16.15-.26,7.23-.27,16.15-.27S260.36,162.72,260.36,162.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,208.57a9.78,9.78,0,0,1-4.48,0,9.78,9.78,0,0,1,4.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,219.41c0,.14-5.4.26-12.07.26s-12.06-.12-12.06-.26,5.4-.26,12.06-.26S207,219.27,207,219.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,208.57a44.48,44.48,0,0,1-6.86.26,44.48,44.48,0,0,1-6.86-.26,46,46,0,0,1,6.86-.26A46,46,0,0,1,245,208.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.06,218.83c0,.14-5.53.26-12.35.26s-12.36-.12-12.36-.26,5.53-.26,12.36-.26S249.06,218.69,249.06,218.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8,208.72a83.52,83.52,0,0,1-9.25.26,83.52,83.52,0,0,1-9.25-.26,80.68,80.68,0,0,1,9.25-.26A80.68,80.68,0,0,1,289.8,208.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,219.26c0,.15-5.33.26-11.91.26s-11.92-.11-11.92-.26,5.33-.26,11.92-.26S293.26,219.12,293.26,219.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.38,
    y: 229.52,
    width: 72.88,
    height: 20.95,
    rx: 2.55,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,240.35c0,.14-9.38.26-20.95.26s-21-.12-21-.26,9.38-.26,21-.26S247.48,240.2,247.48,240.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.29,
    y: 229.13,
    width: 20.82,
    height: 21.47,
    rx: 2.37,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.45 238.77 279.94 238.77 277.89 241.92 275.45 238.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,266.05c0,.15-11.59.26-25.88.26s-25.88-.11-25.88-.26,11.59-.26,25.88-.26S261.26,265.91,261.26,266.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.32,275.8c0,.14-17,.26-38,.26s-38-.12-38-.26,17-.26,38-.26S276.32,275.66,276.32,275.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,292.7c0,.15-36.45.27-81.42.27s-81.42-.12-81.42-.27,36.45-.26,81.42-.26S320,292.56,320,292.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,311.67a83,83,0,0,1-.26-9.22,82.77,82.77,0,0,1,.26-9.21,80,80,0,0,1,.26,9.21A80.21,80.21,0,0,1,240.2,311.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.09,176.52l-4.68,10.74h-2l-4.69-10.74h2.16l3.57,8.28,3.61-8.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,183.78h-6.43a2.49,2.49,0,0,0,2.66,2,2.92,2.92,0,0,0,2.22-.89l1,1.18a4.17,4.17,0,0,1-3.3,1.33c-2.74,0-4.52-1.76-4.52-4.2A4.06,4.06,0,0,1,234,179a4,4,0,0,1,4.14,4.23C238.13,183.36,238.11,183.59,238.1,183.78Zm-6.44-1.28h4.64a2.22,2.22,0,0,0-2.31-2A2.26,2.26,0,0,0,231.66,182.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.71,179v1.82a2.47,2.47,0,0,0-.44-.05,2.23,2.23,0,0,0-2.38,2.53v4H240v-8.19h1.83v1.19A3.23,3.23,0,0,1,244.71,179Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.08,176.57a1.16,1.16,0,0,1,1.23-1.15,1.13,1.13,0,0,1,1.22,1.1,1.23,1.23,0,0,1-2.45,0Zm.26,2.5h1.92v8.19h-1.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,175.77a3.07,3.07,0,0,1,1.74.45l-.54,1.44a1.88,1.88,0,0,0-1.06-.34c-.8,0-1.21.44-1.21,1.32v.49h2.26v1.53H253v6.6H251v-6.6h-1.34v-1.53H251v-.52A2.65,2.65,0,0,1,254,175.77Zm3.44.8a1.16,1.16,0,0,1,1.23-1.15,1.13,1.13,0,0,1,1.22,1.1,1.23,1.23,0,0,1-2.45,0Zm.26,2.5h1.92v8.19h-1.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.76,183.78h-6.42a2.48,2.48,0,0,0,2.65,2,3,3,0,0,0,2.23-.89l1,1.18a4.15,4.15,0,0,1-3.3,1.33c-2.74,0-4.52-1.76-4.52-4.2a4.07,4.07,0,0,1,4.23-4.18,4,4,0,0,1,4.14,4.23C269.79,183.36,269.78,183.59,269.76,183.78Zm-6.44-1.28H268a2.23,2.23,0,0,0-2.32-2A2.27,2.27,0,0,0,263.32,182.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.66,175.88v11.38h-1.84V186.2a3.39,3.39,0,0,1-2.71,1.16,4.19,4.19,0,0,1,0-8.38,3.34,3.34,0,0,1,2.63,1.1v-4.2Zm-1.89,7.28a2.44,2.44,0,1,0-2.44,2.56A2.4,2.4,0,0,0,277.77,183.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.61,
    cy: 181.54,
    r: 8.41,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.81 181.7 200.89 180.62 202.98 182.47 207.07 178.53 208.07 179.61 202.82 184.55 199.81 181.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,389.09l-66,0A17.82,17.82,0,0,1,156,371.24V311.67h83.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,389.25,239,389.09V311.67h80.18v59.07A18.91,18.91,0,0,1,300.63,389.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,311.67c0,.14-36.45.26-81.41.26s-81.42-.12-81.42-.26,36.44-.26,81.42-.26S320,311.53,320,311.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.37,357s-.09,0-.23-.14l-.63-.46-2.38-1.78-8.7-6.64c-1.83-1.39-3.85-3-6-4.57a3.53,3.53,0,0,0-3.75.13,15.38,15.38,0,0,0-1.56,1.49l-1.59,1.61-14,14.14-.86.87-.16.16-.18-.13-8.08-6-3.84-2.87a3.63,3.63,0,0,0-4-.67,7.09,7.09,0,0,0-1.66,1.33l-1.58,1.47-3,2.8-5.4,5-7.83,7.22-2.15,1.94-.56.5q-.19.17-.21.15a1,1,0,0,1,.17-.19l.53-.53,2.08-2,7.72-7.34,5.36-5.06,3-2.81,1.57-1.48.8-.75a4.15,4.15,0,0,1,1-.67,3.93,3.93,0,0,1,2.35-.34,3.76,3.76,0,0,1,1.16.38,6,6,0,0,1,1,.67l3.85,2.85,8.09,6-.34,0,.86-.88,14-14.11,1.6-1.6a15,15,0,0,1,1.63-1.54,4,4,0,0,1,4.23-.12c2.22,1.65,4.16,3.23,6,4.65l8.6,6.77,2.33,1.86.59.5A1,1,0,0,1,237.37,357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,331c-.06,0,0-.64-.33-1.75a7.25,7.25,0,0,0-2.66-3.88,7,7,0,0,0-3-1.29,7.14,7.14,0,0,0-3.69.32,7,7,0,0,0-3.26,2.46,7,7,0,0,0,0,8.29,7.1,7.1,0,0,0,6.95,2.78,6.93,6.93,0,0,0,3-1.3,7.25,7.25,0,0,0,2.66-3.88c.3-1.1.27-1.75.33-1.75a2.42,2.42,0,0,1,0,.47,5.85,5.85,0,0,1-.15,1.33,7.23,7.23,0,0,1-2.63,4.12,7.35,7.35,0,0,1-3.13,1.43,7.48,7.48,0,0,1-7.44-2.9,7.46,7.46,0,0,1,0-8.89,7.46,7.46,0,0,1,3.5-2.61,7.56,7.56,0,0,1,3.94-.3,7.47,7.47,0,0,1,3.13,1.43,7.26,7.26,0,0,1,2.63,4.12,5.92,5.92,0,0,1,.15,1.34A2.35,2.35,0,0,1,204.66,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.7,354.52s-.08,0-.22-.14l-.6-.45-2.3-1.79-8.39-6.65c-1.76-1.39-3.7-3-5.77-4.57a3.24,3.24,0,0,0-3.62.19,17.45,17.45,0,0,0-1.49,1.49l-1.52,1.61L279.4,358.3l-.84.87-.16.17-.19-.14-7.79-6-3.7-2.87a3.34,3.34,0,0,0-3.88-.62,7.92,7.92,0,0,0-1.59,1.34l-1.51,1.47-2.89,2.79-5.19,5-7.51,7.2-2.06,1.94-.55.49c-.12.11-.19.17-.2.16a1,1,0,0,1,.17-.19c.13-.15.3-.32.5-.53l2-2,7.4-7.32,5.14-5.05c.93-.9,1.88-1.84,2.87-2.81l1.5-1.47.77-.75a4.14,4.14,0,0,1,.92-.68,3.72,3.72,0,0,1,2.3-.39,3.55,3.55,0,0,1,1.14.37,6.49,6.49,0,0,1,1,.67l3.7,2.86,7.8,6-.35,0,.84-.88,13.42-14.06,1.53-1.6a17.48,17.48,0,0,1,1.56-1.54,3.71,3.71,0,0,1,4.12-.19c2.15,1.65,4,3.23,5.78,4.65l8.28,6.78,2.23,1.87.57.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.7,328.77c-.05,0,0-.64-.32-1.74a7.18,7.18,0,0,0-2.66-3.88,7.07,7.07,0,0,0-9.93,1.48,7,7,0,0,0,0,8.29,6.94,6.94,0,0,0,3.26,2.45,7,7,0,0,0,6.67-1,7.21,7.21,0,0,0,2.66-3.88,17,17,0,0,0,.32-1.75,1.43,1.43,0,0,1,0,.47,5.85,5.85,0,0,1-.15,1.33A7.25,7.25,0,0,1,280,334.7a7.46,7.46,0,0,1-3.13,1.42,7.36,7.36,0,0,1-3.94-.3,7.44,7.44,0,0,1-3.5-2.6,7.46,7.46,0,0,1,0-8.89,7.48,7.48,0,0,1,7.44-2.9,7.46,7.46,0,0,1,3.13,1.42,7.25,7.25,0,0,1,2.63,4.13,5.85,5.85,0,0,1,.15,1.33A1.33,1.33,0,0,1,282.7,328.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.23,
    cy: 131.33,
    r: 23.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,148.9a14.73,14.73,0,0,0-15-13.15c-8.22,0-13.85,6.22-15,13.2,0,0,5.08,5.62,15,5.54S255.2,148.9,255.2,148.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.23,
    cy: 128.26,
    r: 9.08,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, 75.25, 344.92)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.09,148.11a17.49,17.49,0,0,0-1.41-4.28,14.36,14.36,0,0,0-3.28-4,18,18,0,0,0-5.91-3.32l-.48-.15.44-.23a9,9,0,0,0,3.61-3.61,8.83,8.83,0,1,0-15.56,0,9.08,9.08,0,0,0,1.58,2.12,11.48,11.48,0,0,0,2,1.54l.4.25-.46.13a13.82,13.82,0,0,0-5.92,3.27,15,15,0,0,0-3.1,4.18,17.83,17.83,0,0,0-1.22,3.13c-.11.37-.18.66-.23.85a1.09,1.09,0,0,1-.08.29.85.85,0,0,1,0-.3c0-.2.08-.5.17-.87a16,16,0,0,1,1.13-3.2,14.87,14.87,0,0,1,3.08-4.33,14.09,14.09,0,0,1,6-3.43l-.06.38a12.08,12.08,0,0,1-2.1-1.57,9.54,9.54,0,0,1-1.68-2.22,9.34,9.34,0,0,1,2-11.37,9.3,9.3,0,0,1,12.45,0,9.3,9.3,0,0,1-1.89,15.15l0-.39a17.9,17.9,0,0,1,6,3.47,14.14,14.14,0,0,1,3.27,4.17,12,12,0,0,1,.71,1.82,8.53,8.53,0,0,1,.35,1.39c.05.35.09.64.12.88S255.11,148.11,255.09,148.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,131.33a1.65,1.65,0,0,1-.05-.38c0-.27,0-.63-.08-1.09l-.05-.81c0-.3-.1-.62-.16-1a16.41,16.41,0,0,0-.49-2.39,22.05,22.05,0,0,0-2.57-6.12,23,23,0,0,0-27.6-9.79,23.87,23.87,0,0,0-3,1.32,23.51,23.51,0,0,0-2.81,1.81,25.76,25.76,0,0,0-2.6,2.21,26.33,26.33,0,0,0-2.25,2.66,22.25,22.25,0,0,0-3.27,6.31,22.77,22.77,0,0,0,0,14.47,22.31,22.31,0,0,0,3.27,6.32,27.48,27.48,0,0,0,2.25,2.66,25.76,25.76,0,0,0,2.6,2.21,24.82,24.82,0,0,0,2.81,1.81,23.35,23.35,0,0,0,15,2.33A23.15,23.15,0,0,0,260,143.09a22,22,0,0,0,2.57-6.13,16.3,16.3,0,0,0,.49-2.38c.06-.35.12-.67.16-1l.05-.81c0-.46.06-.82.08-1.1a1.61,1.61,0,0,1,.05-.37,1.83,1.83,0,0,1,0,.38c0,.27,0,.64,0,1.1,0,.25,0,.52,0,.81s-.09.63-.13,1a16.32,16.32,0,0,1-.45,2.41,22.21,22.21,0,0,1-2.52,6.23,23.39,23.39,0,0,1-15.71,11.07,23.46,23.46,0,0,1-12.3-1,24.92,24.92,0,0,1-3.06-1.34,24.56,24.56,0,0,1-2.88-1.84,25.65,25.65,0,0,1-2.66-2.26,26.1,26.1,0,0,1-2.3-2.71,22.69,22.69,0,0,1-3.36-6.46,25.36,25.36,0,0,1-1.21-7.39,25,25,0,0,1,1.22-7.4,22.48,22.48,0,0,1,3.35-6.45,26.22,26.22,0,0,1,2.3-2.72,28,28,0,0,1,2.66-2.25,24.56,24.56,0,0,1,2.88-1.84,24.92,24.92,0,0,1,3.06-1.34,23.43,23.43,0,0,1,12.29-1,23.38,23.38,0,0,1,15.72,11.07,22.16,22.16,0,0,1,2.52,6.22,16.43,16.43,0,0,1,.45,2.42c0,.35.1.68.13,1s0,.57,0,.82c0,.46,0,.83,0,1.1A1.83,1.83,0,0,1,263.39,131.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.44,236.53c-12.16,6.3-21.49,17.15-28.19,29.09s-11,25.05-15.31,38.06l-3.75,67.1c14.15-24.07,25.51-52.37,28.58-80.13l-9.42-.84c6.32-1,11.62-5.54,15-11s5.11-11.69,6.8-17.84l-11.49,1.7A42.55,42.55,0,0,0,144.44,236.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,236.53c-12.16,6.3-21.49,17.15-28.19,29.09s-11,25.05-15.31,38.06l-3.75,67.1c14.15-24.07,25.51-52.37,28.58-80.13l-9.42-.84c6.32-1,11.62-5.54,15-11s5.11-11.69,6.8-17.84l-11.49,1.7A42.55,42.55,0,0,0,144.44,236.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.09,386.51s-30.71-36.77-30.36-71.87H77.14s-13.48-8.86-12.41-13.82,1.42-23.76,1.42-23.76L77.5,279.9s-8.51-4.25-9.58-11S70.4,231,70.4,231s13.83,14.53,18.09,29.42,15.42,32.26,12.14,77.64S95.09,386.51,95.09,386.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.67,390s33.28-22.17,40.67-50.47l-10-2.71s12.78-4.18,13-8.4,4-19.41,4-19.41l-9.74-.2s7.77-1.56,10.1-6.74S165.09,271,165.09,271s-14.3,8.67-21,19.71-19.46,22.56-26.75,59.76S110.67,390,110.67,390Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,263s0,.13.1.38.16.66.27,1.13c.23,1,.55,2.5,1,4.37s.92,4.22,1.45,6.92,1.18,5.78,1.8,9.19c1.32,6.82,2.7,15,4.13,24s2.77,19.07,4,29.59,2.14,20.58,2.86,29.73,1.19,17.41,1.46,24.34c.18,3.47.26,6.61.35,9.37s.14,5.13.16,7.07,0,3.42.05,4.47v1.16c0,.26,0,.4,0,.4a1.6,1.6,0,0,1,0-.4l0-1.16c0-1.05-.09-2.55-.15-4.47s-.13-4.31-.25-7.06-.23-5.89-.42-9.36c-.33-6.93-.88-15.17-1.58-24.32s-1.7-19.19-2.9-29.71-2.6-20.51-4-29.58-2.75-17.22-4-24c-.6-3.42-1.21-6.49-1.72-9.2s-1-5-1.37-6.94-.67-3.35-.87-4.38c-.09-.49-.17-.86-.22-1.15A2.22,2.22,0,0,1,78.8,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.83,409S62.72,377.13,54,357.85L60.59,355c-4.78.79-9.67-1.26-13.38-4.38s-6.42-7.22-9.09-11.26l8.68-1.47a32.25,32.25,0,0,1-19-14.69c10.24,1.69,19.51,7.31,27.14,14.35,6.19,5.69,11.42,12.3,16.45,19.06a64.26,64.26,0,0,1,6.39,10.5C82.54,376.9,90.85,397.31,90.83,409Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.78,289.57a1.29,1.29,0,0,1-.13.32l-.43.93c-.41.84-1,2-1.72,3.53s-1.67,3.41-2.71,5.6-2.25,4.67-3.52,7.44c-2.6,5.53-5.58,12.15-8.79,19.55s-6.56,15.62-9.93,24.3-6.36,17-9,24.65-4.86,14.55-6.66,20.38c-.92,2.91-1.69,5.56-2.4,7.88s-1.29,4.32-1.76,6-.84,2.88-1.11,3.77l-.3,1a1.68,1.68,0,0,1-.12.33,2.09,2.09,0,0,1,.07-.35c.06-.25.15-.57.25-1l1-3.8c.44-1.64,1-3.66,1.67-6s1.43-5,2.33-7.9c1.75-5.85,4-12.77,6.55-20.42s5.62-16,9-24.69,6.77-16.89,10-24.3,6.26-14,8.89-19.51c1.3-2.77,2.53-5.24,3.6-7.42s2-4,2.79-5.56l1.8-3.49.48-.9A1.84,1.84,0,0,1,151.78,289.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.22,422.69a2.66,2.66,0,0,1-.13-.59l-.27-1.69c-.11-.74-.24-1.64-.44-2.68s-.36-2.23-.65-3.53c-.5-2.61-1.22-5.69-2.14-9.09s-2.11-7.06-3.54-10.86-3-7.33-4.52-10.5-3-5.94-4.4-8.23c-.65-1.17-1.3-2.18-1.85-3.08s-1-1.68-1.44-2.3l-.92-1.45a3.31,3.31,0,0,1-.29-.52,2.2,2.2,0,0,1,.38.46l1,1.4c.43.6.95,1.36,1.52,2.25s1.24,1.89,1.91,3.05c1.4,2.27,2.93,5.06,4.52,8.21s3.13,6.72,4.58,10.52,2.59,7.52,3.51,10.93,1.59,6.52,2,9.14c.26,1.31.41,2.51.57,3.56s.28,1.95.35,2.69.13,1.26.17,1.71A2.27,2.27,0,0,1,93.22,422.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.79,
    y: 415.19,
    width: 61.52,
    height: 12.55,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.65 427.74 81.31 469.95 118.48 469.95 124.68 427.74 74.65 427.74",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.54,427.74c0,.14-11.64.26-26,.26s-26-.12-26-.26,11.64-.27,26-.27S126.54,427.59,126.54,427.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.44,236.53c-12.16,6.3-21.49,17.15-28.19,29.09s-11,25.05-15.31,38.06l-3.75,67.1c14.15-24.07,25.51-52.37,28.58-80.13l-9.42-.84c6.32-1,11.62-5.54,15-11s5.11-11.69,6.8-17.84l-11.49,1.7A42.55,42.55,0,0,0,144.44,236.53Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.87,290.69s10.2,16.93,11.72,33.05-9.25,146.38-9.25,146.38H306.44s34-160.85,45.12-171.17l.76-10.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.29,303.6a19.39,19.39,0,0,1-.05,2.27,27.18,27.18,0,0,1-1.21,6.39,29.23,29.23,0,0,1-4.74,9.13,27.53,27.53,0,0,1-4.5,4.63,46,46,0,0,1-6,4c-2.19,1.28-4.53,2.52-6.87,4a29.93,29.93,0,0,0-6.63,5.32,24.19,24.19,0,0,0-4.52,7.85,49.54,49.54,0,0,0-2.07,9.48c-.45,3.3-.74,6.71-1.19,10.19a47.78,47.78,0,0,1-2.4,10.46,23.68,23.68,0,0,1-6.15,9.23,36.69,36.69,0,0,1-9.66,6.13c-7,3.21-14.36,5.26-20.57,9a27.34,27.34,0,0,0-7.85,7,32.22,32.22,0,0,0-4.45,9.11c-2,6.34-2.9,12.67-4.56,18.4-.22.71-.44,1.42-.65,2.12s-.49,1.37-.73,2.05a41.29,41.29,0,0,1-1.74,3.87c-.59,1.25-1.34,2.39-2,3.53-.37.55-.75,1.09-1.12,1.62l-.55.79-.6.75a42.84,42.84,0,0,1-10,9.25,42.37,42.37,0,0,1-9.2,4.64,41.85,41.85,0,0,1-6.29,1.67l-1.67.25-.58.07.57-.12,1.66-.3a43.89,43.89,0,0,0,6.24-1.76,43.13,43.13,0,0,0,19-13.93l.59-.74.55-.79,1.1-1.61c.66-1.13,1.4-2.26,2-3.51a39.28,39.28,0,0,0,1.71-3.83c.24-.67.47-1.35.71-2s.43-1.4.64-2.11c1.64-5.69,2.48-12,4.52-18.43a32.76,32.76,0,0,1,4.51-9.25,27.67,27.67,0,0,1,8-7.17c6.29-3.81,13.63-5.86,20.61-9.06a35.94,35.94,0,0,0,9.53-6,23.19,23.19,0,0,0,6-9A47.44,47.44,0,0,0,398,366.76c.45-3.46.75-6.87,1.21-10.18a50.83,50.83,0,0,1,2.1-9.57,24.93,24.93,0,0,1,4.63-8,30.54,30.54,0,0,1,6.75-5.37c2.36-1.44,4.71-2.68,6.89-3.93a47.11,47.11,0,0,0,6-4,27.68,27.68,0,0,0,4.47-4.54,29.5,29.5,0,0,0,4.77-9,27.84,27.84,0,0,0,1.31-6.34c.08-.74.08-1.3.11-1.69S436.29,303.6,436.29,303.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.85,315.44a4.8,4.8,0,0,1,.19.51,10.67,10.67,0,0,1,.43,1.52,14.65,14.65,0,0,1-.11,6.07,21.61,21.61,0,0,1-4.15,8.65A55.83,55.83,0,0,1,427,341c-3.63,3-7.76,6.21-10.93,10.75a21,21,0,0,0-3.38,7.76,62,62,0,0,0-1,9,47.22,47.22,0,0,1-1.33,9.52,42.05,42.05,0,0,1-3.65,9.35,42.77,42.77,0,0,1-14.08,15.49c-6.11,4-13,5.92-19.05,8.93a31.85,31.85,0,0,0-8.18,5.54,25.87,25.87,0,0,0-5.36,7.77c-2.57,5.66-3.63,11.55-5.06,16.91a69.08,69.08,0,0,1-2.44,7.68,33.49,33.49,0,0,1-3.49,6.56,28,28,0,0,1-4.52,5c-.78.73-1.63,1.33-2.42,1.95s-1.63,1.13-2.47,1.57a30.39,30.39,0,0,1-9,3.5,30,30,0,0,1-6.05.63l-1.58-.08-.54,0h.54l1.58,0a32.07,32.07,0,0,0,6-.73,30.66,30.66,0,0,0,8.86-3.55c.82-.44,1.59-1,2.42-1.57s1.62-1.22,2.39-1.95a28.05,28.05,0,0,0,4.44-5,33.57,33.57,0,0,0,3.42-6.5,69.82,69.82,0,0,0,2.39-7.64c1.42-5.34,2.45-11.26,5-17a26.35,26.35,0,0,1,5.44-7.93,32.2,32.2,0,0,1,8.31-5.63c6.1-3.05,13-5,19-8.91a42.3,42.3,0,0,0,17.54-24.53,47.5,47.5,0,0,0,1.33-9.43,59.63,59.63,0,0,1,1-9.09,21.4,21.4,0,0,1,3.46-7.91c3.24-4.59,7.42-7.81,11.06-10.78A56,56,0,0,0,436,332a21.63,21.63,0,0,0,4.19-8.51,15.25,15.25,0,0,0,.2-6C440.1,316.13,439.81,315.45,439.85,315.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.05,224.86s8.23,56.76,20.89,62.27c6.38,2.79,11.51.39,15-6s12.4-52.82,12.4-52.82l-24.63-.58-.92,9.23-9.5-17.67Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.36,261.92a1.76,1.76,0,0,0-.21-.45l-.67-1.24L344,255.68c-2.12-3.84-5-9.16-8.21-15.05s-6-11.2-8.07-15.13l-2.44-4.59-.67-1.24c-.16-.28-.25-.43-.27-.42a2.52,2.52,0,0,0,.18.46l.6,1.28c.53,1.11,1.31,2.7,2.3,4.67,2,3.92,4.77,9.3,8,15.19s6.14,11.19,8.33,15c1.1,1.9,2,3.42,2.65,4.47l.75,1.2A2.31,2.31,0,0,0,347.36,261.92Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.19 238.13 426.16 269.58 429.49 290.69 352.23 290.69 357.28 192.16 376.54 190.52 423.6 198.47 433.19 238.13",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.54,197.9s20.12-1.85,29.71,11.84c5.87,8.38,14.1,27.63,14.1,27.63L430.56,242Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.74,238.5a16.34,16.34,0,0,0-14.9-9.16c-1.34,0-2.85.36-3.56,1.49s-.32,2.75.2,4.06c.67,1.71,1.56,3.52,3.2,4.34,1.2.6,2.61.57,3.9,1a12.48,12.48,0,0,1,4.14,2.62,11.52,11.52,0,0,1,2.73,2.89,11.21,11.21,0,0,1,1.06,3c1.31,5.14,2.35,15.75,3.65,20.89l1.44-4.43q.06-6.34.11-12.68C427.75,247.72,427.75,242.8,425.74,238.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M401.72,264.72c0-.08,1,.1,2.74.23a32,32,0,0,0,6.59-.16,32.83,32.83,0,0,0,6.42-1.53c1.6-.56,2.56-1,2.59-.93a2.64,2.64,0,0,1-.63.39,18.3,18.3,0,0,1-1.84.85,27,27,0,0,1-13.16,1.72,17.49,17.49,0,0,1-2-.35A2.16,2.16,0,0,1,401.72,264.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,266.1c0-.12,11,3,24.41,7s24.33,7.28,24.29,7.41-11-3-24.42-7S368,266.23,368,266.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.27,264.85a9.68,9.68,0,0,0,9.07,4.21,8.75,8.75,0,0,0,7.35-6A32.15,32.15,0,0,1,402.27,264.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M413.77,279.51l-.28.11c-6.9,1.23-13.37,0-20-2.36s-12.77-5.74-18.88-9.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,192.16s-12.74,1.56-17.68,12.44A190.35,190.35,0,0,0,331,228.48l26,5.85s4.09-22,4.4-29.73C361.75,196.11,362.09,191.91,357.28,192.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.83,237.81a56.39,56.39,0,0,1-.22-7.29,56.94,56.94,0,0,1,.25-7.28,56.16,56.16,0,0,1,.22,7.28A57.17,57.17,0,0,1,354.83,237.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.94,122.45c6.87-8.4,16.11-13.24,27-13.42,6.12-.1,8.66,1.17,13.07,2.36a19.35,19.35,0,0,1,11,7.29c3.13,4.44,5.76,9.41,6.35,14.8.6,5.55,1.21,11.13.79,16.69s-1.92,11.15-5.2,15.67L407.8,168.3c-7.82.26-15.74.52-23.35-1.26s-15-5.88-19.08-12.55C359.71,145.22,362.06,130.86,368.94,122.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,173.8s.23.35.85.74a6.9,6.9,0,0,0,2.91,1,7.53,7.53,0,0,0,4.5-.91,7.55,7.55,0,0,0,2.72-10.07,7.53,7.53,0,0,0-3.42-3.05,7,7,0,0,0-3-.62,2.19,2.19,0,0,0-1.1.21A10.66,10.66,0,0,1,425,162a7.33,7.33,0,0,1,3,2.9,7,7,0,0,1-2.44,9,7.25,7.25,0,0,1-4,1A10.5,10.5,0,0,1,417.66,173.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22,163.52a10.59,10.59,0,0,1,4.79-8,7.6,7.6,0,0,1,8.93.77l2.23,2.65a9.15,9.15,0,0,1,5.25,9.21,10,10,0,0,1-6.94,8.19,11.08,11.08,0,0,1-10.54-2.55A12.44,12.44,0,0,1,355.22,163.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,173.06a4.74,4.74,0,0,1-.76-2.82c.12-1.81,1.43-4.18,3.23-6.35a19.16,19.16,0,0,1,5.67-4.55c1.66-.89,2.8-1.21,2.76-1.33a7.67,7.67,0,0,0-3,.89,16.93,16.93,0,0,0-6,4.54,16.54,16.54,0,0,0-2.29,3.48,7.56,7.56,0,0,0-.91,3.31,3.93,3.93,0,0,0,.63,2.24C357.73,172.93,358,173.09,358,173.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,177.24c.23,0-.73-4.29.63-9.35s4.22-8.32,4-8.45a7.61,7.61,0,0,0-1.87,2.1,19.51,19.51,0,0,0-2.83,6.18,19.76,19.76,0,0,0-.56,6.77A7.81,7.81,0,0,0,364.87,177.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.8,191.25c-.09-5-.21-9-.21-9s11.54-1.27,14.72-16.05c1.59-7.35,1.88-19.54,1.8-29.51-.07-9-7.72-21.2-18.8-21.24l-4.93-.58-18.86,7.5a5.25,5.25,0,0,0-5,5.06L376,190.57l18.23,44.26,13.08-17.73Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.14,162.73a3.12,3.12,0,0,1,1.08-1.94,3.23,3.23,0,0,1,3.91-.23,4.3,4.3,0,0,1,1.63,4.05h0a3.89,3.89,0,0,1-2.8,1.62,4.61,4.61,0,0,1-.53,0,3.5,3.5,0,0,1-2.37-.94A3.12,3.12,0,0,1,400.14,162.73Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.78,146.89a1.91,1.91,0,0,1-1.95,1.83,1.83,1.83,0,0,1-1.88-1.83,1.92,1.92,0,0,1,1.95-1.83A1.83,1.83,0,0,1,416.78,146.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.44,142.22c-.25.23-1.64-.92-3.7-1s-3.62.84-3.83.58.16-.56.84-1a5.34,5.34,0,0,1,3.09-.77,5.08,5.08,0,0,1,2.93,1.13C420.37,141.65,420.56,142.11,420.44,142.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.51,157.81a13.23,13.23,0,0,1,3.37-.42c.53,0,1-.1,1.14-.46a2.61,2.61,0,0,0-.26-1.57c-.43-1.3-.87-2.67-1.34-4.09-1.84-5.82-3.15-10.59-2.91-10.66s1.92,4.58,3.76,10.4c.44,1.43.87,2.8,1.27,4.11a3,3,0,0,1,.16,2.07,1.28,1.28,0,0,1-.91.72,3.26,3.26,0,0,1-.9.08A13.09,13.09,0,0,1,407.51,157.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,182.24a38,38,0,0,1-19.68-6.42s4.75,10.63,19.76,10.05Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.37,158.9c.34,0,.22,2.23,2,3.92s4.22,1.58,4.22,1.89c0,.14-.55.41-1.56.38a5.6,5.6,0,0,1-3.53-1.45,4.89,4.89,0,0,1-1.57-3.28C400.94,159.42,401.22,158.88,401.37,158.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,134.46c-.37.48-1.93.06-3.78.11s-3.4.45-3.78,0c-.17-.23.06-.71.72-1.18a5.52,5.52,0,0,1,3.05-.89,5.4,5.4,0,0,1,3.05.82C420,133.75,420.19,134.22,420,134.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.83,146.35a1.91,1.91,0,0,0,1.81,2,1.84,1.84,0,0,0,2-1.69,1.91,1.91,0,0,0-1.81-2A1.83,1.83,0,0,0,392.83,146.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.24,141.48c.23.25,1.7-.8,3.76-.76s3.55,1.1,3.78.85-.12-.56-.77-1a5.27,5.27,0,0,0-3-1,5,5,0,0,0-3,.91C392.34,140.92,392.12,141.36,392.24,141.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.05,137.05c.4.48,2,0,3.91,0s3.53.38,3.91-.11c.16-.23-.08-.7-.78-1.16a6,6,0,0,0-3.17-.82,5.85,5.85,0,0,0-3.13.88C391.11,136.34,390.88,136.82,391.05,137.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,152.49c.06-1.12-1.08-3.8-2.17-4-2.9-.61-8.2-.67-8.65,6.77-.63,10.16,9.7,8.69,9.74,8.4S378.9,156.32,379.1,152.49Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,159.74c-.05,0-.19.11-.5.23a1.79,1.79,0,0,1-1.32-.05c-1.05-.46-1.85-2.23-1.79-4.06a5.9,5.9,0,0,1,.65-2.51,2,2,0,0,1,1.42-1.27.89.89,0,0,1,1,.55c.12.29.05.49.1.51s.23-.16.17-.58a1.1,1.1,0,0,0-.36-.66,1.29,1.29,0,0,0-1-.32,2.48,2.48,0,0,0-1.95,1.46,6.1,6.1,0,0,0-.79,2.79c-.06,2.06.87,4,2.32,4.55a1.89,1.89,0,0,0,1.63-.17C375.41,160,375.48,159.76,375.45,159.74Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.51,148.48l2.59,2.68c11.15-10.67,32.95-37.4,31.73-35.81a32.49,32.49,0,0,0-15.93-1.73c-8.3,1.41-24,5.56-23.78,15.35S376.51,148.48,376.51,148.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.75,173.8s-.23.35-.84.74a6.9,6.9,0,0,1-2.92,1,7.5,7.5,0,0,1-4.49-.91,7.56,7.56,0,0,1-2.73-10.07,7.55,7.55,0,0,1,3.43-3.05,6.94,6.94,0,0,1,3-.62,2.31,2.31,0,0,1,1.11.21,10.66,10.66,0,0,0-3.86.94,7.35,7.35,0,0,0-3,2.9,7,7,0,0,0,2.44,9,7.3,7.3,0,0,0,4.06,1A10.39,10.39,0,0,0,376.75,173.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.74,146.24a3.36,3.36,0,0,1,.16-.59,10.27,10.27,0,0,1,.69-1.6,14.81,14.81,0,0,1,4.25-4.78,27.91,27.91,0,0,1,8.55-4.12c3.4-1.1,7.24-2,11-3.58a49.71,49.71,0,0,0,10-5.62,52.1,52.1,0,0,0,7.09-6.2,56.31,56.31,0,0,0,4.1-4.86l1-1.41A3.21,3.21,0,0,1,409,113a2.13,2.13,0,0,1-.29.53c-.22.34-.52.84-1,1.46a44.9,44.9,0,0,1-4,5,49.62,49.62,0,0,1-7.07,6.33,48.75,48.75,0,0,1-10.13,5.72,109.31,109.31,0,0,1-11,3.56,28.34,28.34,0,0,0-8.48,3.95,15.41,15.41,0,0,0-4.29,4.59C362,145.45,361.8,146.26,361.74,146.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7,147.84a5.36,5.36,0,0,1,.4-2.22,10.4,10.4,0,0,1,3.82-4.79c2.12-1.58,5.15-2.56,8.48-3.32a50,50,0,0,0,10.54-3.35,44.87,44.87,0,0,0,9.4-5.8,46.21,46.21,0,0,0,6.44-6.33,48.59,48.59,0,0,0,3.59-4.94l.86-1.42a2.84,2.84,0,0,1,.33-.48,1.87,1.87,0,0,1-.24.53c-.2.39-.46.88-.78,1.48a41.19,41.19,0,0,1-3.48,5.06,43.86,43.86,0,0,1-15.9,12.38A48.82,48.82,0,0,1,377.51,138c-3.33.74-6.29,1.66-8.38,3.16a10.53,10.53,0,0,0-3.84,4.56A11.85,11.85,0,0,0,364.7,147.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.08,230.4c-.57-.21-1.32-8.3-1.32-8.3s-8.09-6.47-9.19-9.1-.94-8.9-.94-8.9l13.25-9s7.83,7,9.88,9.76c1.15,1.54,2,5.79,2.6,9.23a35.42,35.42,0,0,1,.33,8.85l-.19,2.28S321.17,233.78,312.08,230.4Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18,214.59a34.35,34.35,0,0,1-2.71-2.69c-1.72-1.86-3.63-3.6-2-5.57a2.88,2.88,0,0,1,2.07-1.14s-1-1.73-.13-2.82a2.54,2.54,0,0,1,2.1-1s-1.29-2.48-.1-4.15a4.08,4.08,0,0,1,4-1.58s-5.37-10.94-5.69-11.5c-1.2-2.07-1.09-4.33,1.31-4.58.88-.09,1.64.6,3.92,4s6.1,9.15,6.1,9.15,4.17,3.53,6.26,5.51,6.46,6.62,7.19,8c1.87,3.59,1.47,9.37,1.47,9.37l-15.2,6.51S303.16,215.46,302.18,214.59Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,205.57a14.78,14.78,0,0,1,1.8,1.25l1.91,1.42a8.23,8.23,0,0,1,1.08.93,2.46,2.46,0,0,1,.72,1.41,1.57,1.57,0,0,1-.56,1.5,2,2,0,0,1-1.46.33,6.52,6.52,0,0,1-1.26-.26c-.39-.11-.74-.22-1.07-.33-.64-.21-1.16-.4-1.51-.55s-.53-.24-.52-.27.81.23,2.1.59a14.8,14.8,0,0,0,2.29.51,1.85,1.85,0,0,0,1.22-.28,1.29,1.29,0,0,0,.43-1.2,2.22,2.22,0,0,0-.63-1.22,8,8,0,0,0-1-.91L301.67,207A12.63,12.63,0,0,1,300,205.57Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.23,202.33a5.55,5.55,0,0,1-.71-2.5,5.64,5.64,0,0,1,.15-2.59c.11,0,0,1.16.19,2.56S313.33,202.3,313.23,202.33Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.59,203.44a11,11,0,0,0-6.17-.83,20.58,20.58,0,0,0-6,1.9c-1.52.72-3.18,1.78-3.39,3.45s1.36,3.27,3.06,3.6a8.41,8.41,0,0,0,5-1,21,21,0,0,1,4.8-2",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.91,208.61s-.45.11-1.24.41a34.44,34.44,0,0,0-3.21,1.51,14.35,14.35,0,0,1-2.29.94,6.68,6.68,0,0,1-2.85.29,4.22,4.22,0,0,1-2.76-1.56,3.22,3.22,0,0,1-.7-1.57,3.05,3.05,0,0,1,.34-1.75,5.92,5.92,0,0,1,2.57-2.23,26.88,26.88,0,0,1,2.88-1.24,15.81,15.81,0,0,1,5.21-1,10.35,10.35,0,0,1,3.53.53,7.46,7.46,0,0,1,.91.37,1.6,1.6,0,0,1,.29.17s-.43-.18-1.24-.41a11.33,11.33,0,0,0-3.49-.41,15.93,15.93,0,0,0-5.1,1.09,25.4,25.4,0,0,0-2.83,1.24,5.6,5.6,0,0,0-2.42,2.1,2.51,2.51,0,0,0-.3,1.53,2.89,2.89,0,0,0,.61,1.41,4,4,0,0,0,2.54,1.46,6.67,6.67,0,0,0,2.73-.25,14.92,14.92,0,0,0,2.27-.89,29.17,29.17,0,0,1,3.27-1.42,7.19,7.19,0,0,1,.94-.24A1.24,1.24,0,0,1,317.91,208.61Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.19,205.71c2.53,1.89,5,4.1,7.28,6.23a5.26,5.26,0,0,0,2.3,1.47c.71.15,1.94-1,2.51-1.5l-8.17-8.58",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,203.33a4.06,4.06,0,0,1,.68.61l1.76,1.78c1.49,1.52,3.55,3.65,5.86,6.07l.12.13-.14.12a16,16,0,0,1-1.37,1.1,4.07,4.07,0,0,1-.65.35,1.24,1.24,0,0,1-.38.09,1,1,0,0,1-.4,0,3.79,3.79,0,0,1-1.25-.64c-.73-.56-1.31-1.17-1.92-1.71-1.2-1.1-2.28-2.08-3.2-2.89s-1.69-1.45-2.22-1.89a8.35,8.35,0,0,1-.81-.7,5,5,0,0,1,.89.6c.56.4,1.35,1,2.29,1.8s2.06,1.75,3.26,2.85c.61.53,1.22,1.15,1.91,1.67a3.42,3.42,0,0,0,1.14.58,1.46,1.46,0,0,0,1.14-.36,15.86,15.86,0,0,0,1.35-1.07V212c-2.31-2.43-4.33-4.59-5.78-6.15L304.7,204A7.49,7.49,0,0,1,304.11,203.33Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,200.73l8.24,9.28a7.77,7.77,0,0,0,1.95,1.76,2.66,2.66,0,0,0,2.52.16,2.72,2.72,0,0,0,1-3.19,8.51,8.51,0,0,0-2-3,72.56,72.56,0,0,1-6.77-9",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.77,196.71s.09.09.23.29l.6.87c.53.75,1.29,1.83,2.27,3.14s2.21,2.82,3.63,4.45a11.27,11.27,0,0,1,2,2.77,3.5,3.5,0,0,1,.29,1.84,2.66,2.66,0,0,1-.84,1.74,2.29,2.29,0,0,1-1.87.51,3.61,3.61,0,0,1-1.71-.74,21,21,0,0,1-2.37-2.47l-3.79-4.33c-1.05-1.21-1.9-2.21-2.53-2.94L302,201a1.57,1.57,0,0,1-.22-.3s.1.08.27.25l.73.77,2.61,2.87,3.85,4.28a21.2,21.2,0,0,0,2.34,2.41,3.27,3.27,0,0,0,1.55.67,2,2,0,0,0,1.6-.43,2.32,2.32,0,0,0,.72-1.52,3.15,3.15,0,0,0-.26-1.66,11.13,11.13,0,0,0-2-2.7c-1.42-1.64-2.62-3.19-3.58-4.52s-1.7-2.43-2.19-3.21c-.24-.39-.43-.69-.55-.9A1.48,1.48,0,0,1,306.77,196.71Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.34,218a1.86,1.86,0,0,1-1,.21,5.28,5.28,0,0,1-2.37-.42,5.46,5.46,0,0,1-2-1.39,2.13,2.13,0,0,1-.53-.85,7.07,7.07,0,0,0,5.86,2.45Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.13,191.84l-2.88,36.34a2.37,2.37,0,0,1-2.52,2.18L398.48,229a2.36,2.36,0,0,1-2.21-2.58l3.31-36.31a2.37,2.37,0,0,1,2.51-2.16l19.83,1.29A2.38,2.38,0,0,1,424.13,191.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.12,238.1s6.05,40.88,5.81,46.37-6.45,17.68-14.81,18.87-16.24-6.45-16.48-16.48-1.48-41.75-1.48-41.75l6.24-3.44Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67,204.32s6.26,3.85,8.11,4.86,1.61,8.47,1.61,8.47l10.54,24.5-12.7,4.55s-4.53-8.57-5.83-9.65a8.58,8.58,0,0,0-3-1.52s-.65,2.38-2.6,1.3a18.87,18.87,0,0,1-4.12-3.69s-1.74,1.09-2.39-.21-1.73-4.12-1.73-4.12,3.68-4.77,5.2-4.77,9.32.43,9.32.43-.43-.65-2.6-1.51-15.07-4.67-15.68-4.9c-.91-.35-1.93-2.72.89-2.94s18.69,2.62,18.69,2.62.87-4.1.22-5S416.28,208.22,418.67,204.32Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63,233a4.22,4.22,0,0,1,.05-1.78,3.23,3.23,0,0,1,1-1.76,3.7,3.7,0,0,1,2.33-.7,21.52,21.52,0,0,1,4.27.15,5.41,5.41,0,0,1,1.72.4c0,.15-2.68-.3-6-.08a3.5,3.5,0,0,0-2.08.56,3,3,0,0,0-.91,1.51A16.47,16.47,0,0,1,410.63,233Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15,233.73a25.12,25.12,0,0,1,2.43,1.15,21.24,21.24,0,0,1,2.5,1,5,5,0,0,1-2.69-.58A4.74,4.74,0,0,1,413.15,233.73Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.63,217.65a4.1,4.1,0,0,1,3.42,3.31c-.13,0-.56-1-1.51-1.86S421.58,217.78,421.63,217.65Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,436.42c-.14,0,5.32-23,12.2-51.28S338.18,334,338.32,334s-5.32,23-12.2,51.29S313.56,436.45,313.42,436.42Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.07,469.8c0,.14-95.4.26-213.06.26s-213.09-.12-213.09-.26,95.39-.26,213.09-.26S463.07,469.65,463.07,469.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.4,109.18l2.94-10.61a29.68,29.68,0,1,1,7.1,7.89v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4,109.18l.67-.2,1.93-.54,7.42-2.08-.07.19v0a.12.12,0,0,1,0-.16.14.14,0,0,1,.15,0A29.35,29.35,0,0,0,437,112.13a28.84,28.84,0,0,0,9.48-.12A29.46,29.46,0,0,0,470.3,88.9a29.81,29.81,0,0,0-.44-13.36,29.08,29.08,0,0,0-18.18-20,29.41,29.41,0,0,0-39.52,28.84,29.42,29.42,0,0,0,4.28,14.09.17.17,0,0,1,0,.1c-1,3.41-1.73,6-2.25,7.83-.25.89-.45,1.56-.59,2s-.21.71-.21.71.05-.22.16-.67.3-1.14.54-2c.48-1.83,1.2-4.5,2.12-8l0,.1a29.6,29.6,0,0,1,1.43-33.36,29.9,29.9,0,0,1,40.45-7,30.83,30.83,0,0,1,5.42,4.68,31.45,31.45,0,0,1,4.23,5.87,30.42,30.42,0,0,1,3,20.2,29.8,29.8,0,0,1-24.22,23.4,29,29,0,0,1-9.61.08,29.68,29.68,0,0,1-13.6-5.93l.17-.16v0a.11.11,0,0,1,0,.16l0,0-7.55,2L414,109Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.31 83.79 431.77 80.32 438.45 86.26 451.56 73.64 454.78 77.11 437.96 92.94 428.31 83.79",
    style: {
      fill: "#FF725E"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.2606374e26a30ef60e6c2434173edd57.svg";
export { ForwardRef as ReactComponent };